<ng-template #contentTemplate>
    <div id="sidebar-menu">
        <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
            <li class="menu-title" style="color: #fff;">
                Menu
            </li>
            <li *ngIf="checkAkses('dashboard')" (click)="setTitle()">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/dashboard']">
                    <i class="fa fa-home "></i>
                    <span>
                        Dashboard
                    </span>
                </a>
            </li>
            <li *ngIf="checkAkses('pengaturan') || checkAkses('fitur') || checkAkses('paket') || checkAkses('user') || checkAkses('reminder_masa_aktif  ')" (click)="setTitle()">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/pengaturan']">
                    <i class="fas fa-cog"></i>
                    <span>
                        Pengaturan
                    </span>
                </a>
            </li>
            <!-- <li *ngIf="checkAkses('fitur')">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/fitur']">
                    <i class="fas fa-list"></i>
                    <span>
                        Fitur
                    </span>
                </a>
            </li> -->
            <!-- <li *ngIf="checkAkses('paket')">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/paket']">
                    <i class="fas fa-swatchbook"></i>
                    <span>
                        Paket
                    </span>
                </a>
            </li> -->
            <li *ngIf="checkAkses('klien')" (click)="setTitle()">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/klien', 3]">
                    <i class="fas fa-users-cog"></i>
                    <span>
                        Klien
                    </span>
                </a>
            </li>
            <!-- <li *ngIf="checkAkses('user')">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/user']">
                    <i class="fas fa-user"></i>
                    <span>
                        User
                    </span>
                </a>
            </li> -->
            <!-- <li *ngIf="checkAkses('user')">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/userlogklien']">
                    <i class="fas fa-user"></i>
                    <span>
                        User Log Klien
                    </span>
                </a>
            </li> -->
            <!-- <li *ngIf="checkAkses('invoice')" (click)="setTitle()">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/invoice']">
                    <i class="fas fa-money-check"></i>
                    <span>
                        Invoice
                    </span>
                </a>
            </li> -->
            <!-- <li (click)="setTitle()">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/tracking-pembayaran']">
                    <i class="fas fa-money-bill"></i>
                    <span>
                        Tracking Pembayaran
                    </span>
                </a>
            </li> -->
            <li *ngIf="checkAkses('voucher')" (click)="setTitle()" style="display: none;">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/voucher']">
                    <i class="fas fa-tag"></i>
                    <span>
                        Voucher
                    </span>
                </a>
            </li>
            <li *ngIf="checkAkses('promo')" (click)="setTitle()" style="display: none;">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/promo']">
                    <i class="fas fa-percent"></i>
                    <span>
                        Promo
                    </span>
                </a>
            </li>
            <!-- <li>
                <a href="javascript:void(0)" (click)="logout()">
                    <i class="fas fa-sign-out-alt"></i>
                    <span>
                        Logout
                    </span>
                </a>
            </li> -->
            <li *ngIf="checkAkses('pengaturan') || checkAkses('fitur') || checkAkses('paket') || checkAkses('user') || checkAkses('reminder_masa_aktif  ')" (click)="setTitle()" style="display: none;">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/referral']">
                    <i class="fas fa-receipt"></i>
                    <span>
                        Referral
                    </span>
                </a>
            </li>
            <li *ngIf="checkAkses('user_log_all_klien')" (click)="setTitle()">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/userlogallklien']">
                    <i class="fas fa-history"></i>
                    <span>
                        User Log Klien
                    </span>
                </a>
            </li>
            <li (click)="setTitle()">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/monitoringlogin']">
                    <i class="fas fa-history"></i>
                    <span>
                        Monitoring Login
                    </span>
                </a>
            </li>
            <li (click)="setTitle()">
                <a href="javascript:void(0)" [routerLink]="['/backoffice/pertanyaanuser']">
                    <i class="fas fa-question-circle"></i>
                    <span>
                        Pertanyaan User
                    </span>
                </a>
            </li>
        </ul>
    </div>
</ng-template>
<div class="vertical-menu">
    <perfect-scrollbar [config]="configData">
        <div *ngIf="!isCondensed">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </div>
        <div *ngIf="isCondensed">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </div>
    </perfect-scrollbar>
</div>